module.exports = __webpack_public_path__ + "img/shirt.b2790b8c.svg";